import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from "@angular/core";
import { KreFormFieldConfig } from "@kre-form/core";
import * as _ from "lodash";
import { DataService } from "../../service/data.service";

import { ITreeData, ICheckedTree } from "../../tools/util";

@Component({
  selector: "kreform-tree",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.less"],
  providers: [DataService]
})
export class KreFormTree implements OnInit, OnChanges {
  @Input() fieldConfig: KreFormFieldConfig = {};
  @Input() tag: boolean = false;
  @Output() treeChangeEvent = new EventEmitter<any>();

  treeData: ITreeData[] = [];
  controlid: string = "";
  selectData: ICheckedTree[] = [];

  //选择节点
  get selectedNode() {
    return _.cloneDeep(this.selectData);
  }

  get selectType() {
    let res = "";
    if (
      this.fieldConfig != undefined &&
      this.fieldConfig != null &&
      this.fieldConfig.templateOptions != undefined &&
      this.fieldConfig.templateOptions != null &&
      this.fieldConfig.templateOptions.selectType != undefined
    ) {
      res = this.fieldConfig.templateOptions.selectType;
    }
    return res;
  }

  constructor(public dataService: DataService) {}

  ngOnInit() {
    let id = _.get(this.fieldConfig, "templateOptions.treeid");
    if (id != undefined && id != null && id != "") {
      this.controlid = _.get(this.fieldConfig, "templateOptions.treeid");
    }
    this.getTreeData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.defaultNode) {
    }
  }

  //获取Tree数据集
  getTreeData() {
    this.dataService.getTreeData({ id: this.controlid }).subscribe(res => {
      this.treeData = res;

      this.getSelectData();
    });
  }

  getSelectData() {
    if (
      this.fieldConfig != null &&
      this.fieldConfig.model != undefined &&
      this.fieldConfig.model != null &&
      this.fieldConfig.key != undefined &&
      this.fieldConfig.key != null &&
      this.fieldConfig.model[this.fieldConfig.key] != undefined &&
      this.fieldConfig.model[this.fieldConfig.key] != null
    ) {
      this.selectData = _.cloneDeep(
        this.fieldConfig.model[this.fieldConfig.key]
      );
    }
  }
}
